// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  Compact: (t, data?, options?) => t('enum.vocab-type.compact.name', data, options),
  Simple: (t, data?, options?) => t('enum.vocab-type.simple.name', data, options),
  /* eslint-enable max-len */
};
